/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const ViberSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.1em"
    height="1.1em"
    fill="none"
    viewBox="0 0 73 76"
  >
    <path
      fill="#fff"
      d="M64.36 7.38C62.48 5.645 54.881.13 37.956.054c0 0-19.96-1.203-29.69 7.722C2.85 13.193.947 21.12.745 30.947c-.2 9.828-.46 28.245 17.292 33.239h.017l-.011 7.62s-.114 3.085 1.918 3.714c2.457.763 3.899-1.581 6.245-4.109 1.288-1.388 3.066-3.426 4.405-4.984 12.142 1.022 21.48-1.313 22.54-1.659 2.452-.794 16.324-2.571 18.58-20.988 2.33-18.981-1.126-30.988-7.37-36.4z"
    ></path>
    <path
      fill="#7360F2"
      d="M60.412 11.215c-1.59-1.444-8.451-5.756-22.768-5.818 0 0-16.954-1.114-25.184 6.34-4.58 4.523-6.124 11.248-6.293 19.456-.17 8.207-1.046 23.885 13.966 28.056 0 0-.059 11.64-.066 12.663 0 .715.114 1.204.523 1.305.294.072.735-.08 1.11-.454 2.4-2.41 10.085-11.681 10.085-11.681 10.31.673 18.515-1.363 19.397-1.651 2.08-.67 13.331-1.636 15.236-17.017 1.967-15.854-.724-26.677-6.006-31.2z"
    ></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M38.246 24.553a.957.957 0 011.006-.906c1.975.103 3.619.701 4.79 1.911 1.165 1.206 1.737 2.89 1.837 4.913a.957.957 0 11-1.912.094c-.086-1.73-.561-2.91-1.302-3.676-.736-.761-1.86-1.244-3.512-1.33a.957.957 0 01-.907-1.006z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M36.796 19.396a.957.957 0 011.024-.884c4.02.294 7.255 1.667 9.612 4.24 2.331 2.548 3.44 5.716 3.359 9.433a.957.957 0 11-1.914-.041c.07-3.278-.893-5.953-2.857-8.1-1.958-2.136-4.695-3.356-8.34-3.623a.957.957 0 01-.884-1.024z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M35.106 14.494a.957.957 0 01.964-.95c5.555.038 10.25 1.888 14.02 5.563 3.802 3.706 5.682 8.75 5.73 15.017a.957.957 0 01-1.915.014c-.045-5.871-1.791-10.385-5.151-13.66-3.391-3.306-7.602-4.984-12.697-5.02a.957.957 0 01-.951-.964z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#fff"
      d="M39.392 43.339s1.346.113 2.07-.78l1.413-1.776c.68-.882 2.325-1.444 3.935-.547a41.63 41.63 0 013.51 2.242c1.068.786 3.256 2.611 3.263 2.611 1.043.88 1.283 2.173.574 3.535 0 .008-.006.022-.006.029a14.741 14.741 0 01-2.94 3.62c-.013.006-.013.013-.026.02-1.013.846-2.008 1.327-2.985 1.443-.144.025-.29.035-.436.027-.431.005-.86-.061-1.27-.195l-.031-.046c-1.506-.425-4.02-1.488-8.206-3.797a48.866 48.866 0 01-6.895-4.555 36.134 36.134 0 01-3.101-2.75l-.104-.105-.105-.104-.104-.104-.105-.105a36.167 36.167 0 01-2.75-3.1 48.93 48.93 0 01-4.554-6.894c-2.31-4.188-3.373-6.7-3.797-8.208l-.047-.031a3.973 3.973 0 01-.194-1.27c-.008-.146 0-.292.026-.436.122-.976.604-1.971 1.445-2.987.007-.013.014-.013.02-.026a14.71 14.71 0 013.62-2.939c.008 0 .021-.007.03-.007 1.362-.71 2.654-.469 3.533.568.007.007 1.829 2.195 2.611 3.263a41.62 41.62 0 012.242 3.514c.897 1.608.335 3.256-.546 3.935l-1.777 1.413c-.897.724-.78 2.07-.78 2.07s2.633 9.961 12.467 12.472z"
    ></path>
  </svg>
);

export const ViberIcon = (props) => (
  <Icon component={ViberSvg} {...props} />
);
